export function combineEntries(entries, numbers) {
    const totals = new Map();
    for (const [resource, amount] of entries) {
        totals.set(resource, numbers.add(totals.get(resource) ?? numbers.fromNumber(0), amount));
    }
    return [...totals];
}
export function resolveCapacity(resource, current, numbers) {
    const capacity = resource.capacityFor?.(current) ?? resource.capacity;
    if (capacity === undefined)
        return undefined;
    if (!numbers.isFinite(capacity) || numbers.cmp(capacity, numbers.fromNumber(0)) < 0)
        throw new TypeError(`Resource ${resource.id} returned an invalid capacity`);
    return capacity;
}
export function capacityLimits(inputs, outputs, current, numbers) {
    const limits = [];
    const consumed = new Map(combineEntries(inputs, numbers));
    for (const [resource, produced] of combineEntries(outputs, numbers)) {
        const capacity = resolveCapacity(resource, current, numbers);
        if (capacity === undefined || resource.overflow !== "block")
            continue;
        const netPerExecution = numbers.sub(produced, consumed.get(resource) ?? numbers.fromNumber(0));
        if (numbers.cmp(netPerExecution, numbers.fromNumber(0)) <= 0)
            continue;
        limits.push({
            resource,
            capacity,
            netPerExecution,
            room: maximum(numbers.sub(capacity, current(resource)), numbers.fromNumber(0), numbers),
        });
    }
    return limits;
}
export function maximum(left, right, numbers) {
    return numbers.cmp(left, right) >= 0 ? left : right;
}
//# sourceMappingURL=entries.js.map